module.exports = __webpack_public_path__ + "/images/ico-color-click-mobile.e33e804.svg";